import api from '@/api_alv'
import i18n from '../../../assets/i18n/i18n'
import alvPlugin from '@/assets/helpers/alvPlugin'

const DIR = 'publishing/statements'



const state = {
// Publishing Statements List Page    
    publishingStatements: [],
    publishingStatementsLastQuery: null,
    publishingStatementsPendingQuery: null,
    publishingStatementsActionRows: null,
    publishingStatementsActionScope: null,
    publishingStatementsResolvingAction: false,
    selectedPublishingStatements: [],
    expandedPublishingStatements:[],
    isAllSelectedPublishingStatements: false,
    publishingStatementsSearch: "",
    selectedPublishingStatementsArchiveFilter: null,
    publishingStatementsServerSideSortingOptions:{
        sortBy: ['licensor'],
        sortDesc: [false],
        mustSort: true
    },

// Filters & Actions & Buttons
    selectedPublishingStatementsReportOption: [],
    selectedPublishingStatementsAction: [],
    selectedPeriodValues: {
        number: null,
        timeUnit: null,
        year: null
    },
    runningPublishingStatementsPercentValues: [],
    isPublishingStatementsRunning: false,
   
    // Statements preview
    publishingStatementsStatementPreviewDialogDetailsStatementPreviewDate:alvPlugin.dateToISOFormat(new Date()),
    publishingStatementsStatementPreviewDialogCreatePdfCheckbox: true,
    publishingStatementsStatementPreviewDialogC3CalculationCheckbox: true,

    // Archiving
    showPublishingStatementsArchivingDialog: false,
    publishingStatementsArchivingInProgress: false,
    publishingStatementsArchivingTargetCurrency: null,
    publishingStatementsArchivingShowCcfField: false,
    publishingStatementsArchivingCcf: null,
    
    // Details
    publishingStatementsDetails: {},
    selectedPublishingStatementsArchive: [],
    selectedPublishingStatementsForDeleteArchive: '',

    publishingStatementsJournalInProcess: false,
    showPublishingStatementsJournalDialog: false,
    publishingStatementsFakturaInProcess: false,

    // Royalty Controlling
    showPublishingStatementsRoyaltyControllingDialog: false,
    publishingStatementsRoyaltyControllingDialogText: '',
    publishingStatementsRoyaltyControllingShowProgressbar: false,
    publishingStatementsRoyaltyControllingProgressbarValue: null,
    publishingStatementsRoyaltyControllingPath: null,
    publishingStatementsRoyaltyControllingDialogPolling: null,
    publishingStatementsRoyaltyControllingInProcess:false,
    showPublishingStatementsRoyaltyControllingDialogConfirmationButton:false,
    selectedPublishingStatementsReportDropdown: null,
    publishingStatementsRoyaltyControllingDialogAction: null,

    // Assign mappings: group IDs from Abrechnungen (handled via azGroups endpoint)
    publishingStatementsGroupIdsForMapping: [],

    // Bank file generation dialog
    showPublishingStatementsBankFileDialog: false,
    publishingStatementsBankFileDialogDebtor: null,        // { azAlvId, accountHolder, iban, bic, complete }
    publishingStatementsBankFileDialogType: null,          // null = no format chosen yet; user must pick first, then validation runs
    publishingStatementsBankFileDialogExecutionDate: null, // ISO YYYY-MM-DD
    publishingStatementsBankFileDialogIsSubmitting: false,
    publishingStatementsBankFileDialogError: null,         // { errorMsg, skipped: [...], selfTransferConflicts: [...], accountHolderConflicts: [{ name, alvId, role }], currencyConflicts: [{ name, alvId, role }] }
}

const getters = {
    getPublishingStatementsActionScope(state) { return state.publishingStatementsActionScope },
    getPublishingStatementsActionQuery(state) {
        return state.publishingStatementsActionScope ? { searchSession: state.publishingStatementsActionScope.searchSession } : {}
    },
    getPublishingStatementsActionRows(state) {
        return state.publishingStatementsActionRows || state.publishingStatements.filter(
            row => state.selectedPublishingStatements.includes(row.alvId)
        )
    },
    getPublishingStatementsActionIds(state, getters) {
        return getters.getPublishingStatementsActionRows.map(row => row.alvId)
    },
    getShowPublishingStatementsJournalDialog(state) { return state.showPublishingStatementsJournalDialog },
    getPublishingStatementsJournalInProcess(state) { return state.publishingStatementsJournalInProcess },
    getPublishingStatementsFakturaInProcess(state) { return state.publishingStatementsFakturaInProcess },
// Publishing Statements List Page     
    getPublishingStatements(state) { return state.publishingStatements },
    getSelectedPublishingStatements(state) { return state.selectedPublishingStatements },
    getIsAllSelectedPublishingStatements(state) { return state.isAllSelectedPublishingStatements },
    getPublishingStatementsSearch(state) { return state.publishingStatementsSearch },
    getSelectedPublishingStatementsArchiveFilter(state) { return state.selectedPublishingStatementsArchiveFilter },
    getPublishingStatementsServerSideSortingOptions(state){ return state.publishingStatementsServerSideSortingOptions },
    getExpandedPublishingStatements(state) { return state.expandedPublishingStatements },
// Filters & Actions & Buttons
    getSelectedPublishingStatementsReportOption(state) { return state.selectedPublishingStatementsReportOption },
    getSelectedPublishingStatementsAction(state) { return state.selectedPublishingStatementsAction },
    //Statement previev
    getPublishingStatementsStatementPreviewDialogDetailsStatementPreviewDate(state) { return state.publishingStatementsStatementPreviewDialogDetailsStatementPreviewDate },
    getPublishingStatementsStatementPreviewDialogCreatePdfCheckbox          (state) { return state.publishingStatementsStatementPreviewDialogCreatePdfCheckbox },
    getPublishingStatementsStatementPreviewDialogC3CalculationCheckbox      (state) { return state.publishingStatementsStatementPreviewDialogC3CalculationCheckbox },

// Archiving
    getShowPublishingStatementsArchivingDialog              (state) { return state.showPublishingStatementsArchivingDialog  },
    getPublishingStatementsArchivingInProgress              (state) { return state.publishingStatementsArchivingInProgress },
    getPublishingStatementsArchivingTargetCurrency          (state) { return state.publishingStatementsArchivingTargetCurrency },
    getPublishingStatementsArchivingShowCcfField            (state) { return state.publishingStatementsArchivingShowCcfField },
    getPublishingStatementsArchivingDetailsCcf              (state) { return state.publishingStatementsArchivingCcf },
    getPublishingStatementsDetails                          (state) { return state.publishingStatementsDetails },
    getSelectedPublishingStatementsArchive                  (state) { return state.selectedPublishingStatementsArchive },
    getSelectedPublishingStatementsForDeleteArchive         (state) { return state.selectedPublishingStatementsForDeleteArchive },

// Period Filter
    getSelectedPeriodValuesPublishingStatements(state) { return state.selectedPeriodValues },
    getSelectedPeriodNumberPublishingStatements (state) { return state.selectedPeriodValues.number },
    getSelectedPeriodTimeUnitPublishingStatements(state) { return state.selectedPeriodValues.timeUnit },
    getSelectedPeriodYearPublishingStatements(state) { return state.selectedPeriodValues.year },
    getRunningPublishingStatementsPercentValues(state) { return state.runningPublishingStatementsPercentValues },
    getIsPublishingStatementsRunning(state) { return state.isPublishingStatementsRunning },

    // Royalty Controlling
    getShowPublishingStatementsRoyaltyControllingDialog         (state) { return state.showPublishingStatementsRoyaltyControllingDialog },
    getPublishingStatementsRoyaltyControllingDialogText         (state) { return state.publishingStatementsRoyaltyControllingDialogText },
    getPublishingStatementsRoyaltyControllingShowProgressbar    (state) { return state.publishingStatementsRoyaltyControllingShowProgressbar },
    getPublishingStatementsRoyaltyControllingProgressbarValue   (state) { return state.publishingStatementsRoyaltyControllingProgressbarValue },
    getPublishingStatementsRoyaltyControllingPath               (state) { return state.publishingStatementsRoyaltyControllingPath },
    getPublishingStatementsRoyaltyControllingDialogPolling      (state) { return state.publishingStatementsRoyaltyControllingDialogPolling },
    getPublishingStatementsRoyaltyControllingInProcess          (state) { return state.publishingStatementsRoyaltyControllingInProcess },
    getShowPublishingStatementsRoyaltyControllingDialogConfirmationButton(state) { return state.showPublishingStatementsRoyaltyControllingDialogConfirmationButton },
    getSelectedPublishingStatementsReportDropdown               (state) { return state.selectedPublishingStatementsReportDropdown },
    getPublishingStatementsRoyaltyControllingDialogAction       (state) { return state.publishingStatementsRoyaltyControllingDialogAction },
    getPublishingStatementsGroupIdsForMapping                   (state) { return state.publishingStatementsGroupIdsForMapping },

    // Bank file dialog
    getShowPublishingStatementsBankFileDialog                   (state) { return state.showPublishingStatementsBankFileDialog },
    getPublishingStatementsBankFileDialogDebtor                 (state) { return state.publishingStatementsBankFileDialogDebtor },
    getPublishingStatementsBankFileDialogType                   (state) { return state.publishingStatementsBankFileDialogType },
    getPublishingStatementsBankFileDialogExecutionDate          (state) { return state.publishingStatementsBankFileDialogExecutionDate },
    getPublishingStatementsBankFileDialogIsSubmitting           (state) { return state.publishingStatementsBankFileDialogIsSubmitting },
    getPublishingStatementsBankFileDialogError                  (state) { return state.publishingStatementsBankFileDialogError },
}

const mutations = {
    setPublishingStatementsActionScope(state, value) { state.publishingStatementsActionScope = value },
    setPublishingStatementsLastQuery(state, value) { state.publishingStatementsLastQuery = value },
    setPublishingStatementsPendingQuery(state, value) { state.publishingStatementsPendingQuery = value },
    setPublishingStatementsActionRows(state, value) {
        state.publishingStatementsActionRows = value
        state.publishingStatementsActionScope = null
    },
    setPublishingStatementsResolvingAction(state, value) { state.publishingStatementsResolvingAction = value },
    setShowPublishingStatementsJournalDialog(state, value) { state.showPublishingStatementsJournalDialog = value },
    setPublishingStatementsJournalInProcess(state, value) { state.publishingStatementsJournalInProcess = value },
    setPublishingStatementsFakturaInProcess(state, value) { state.publishingStatementsFakturaInProcess = value },
// Publishing Statements List Page     
    setPublishingStatements: (state, statementsFromDB) => { state.publishingStatements = statementsFromDB },
    setSelectedPublishingStatements: (state, selected) => { state.selectedPublishingStatements = selected },
    setIsAllSelectedPublishingStatements: (state, isSelected) => { state.isAllSelectedPublishingStatements = isSelected },
    setPublishingStatementsSearch: (state, search) => { state.publishingStatementsSearch = search },
    setSelectedPublishingStatementsArchiveFilter: (state, value) => { state.selectedPublishingStatementsArchiveFilter = value },
    setPublishingStatementsServerSideSortingOptions: (state, value) => { state.publishingStatementsServerSideSortingOptions = value },
    // setExpandedPublishingStatements: (state, value) => { state.expandedPublishingStatements = value },
    setExpandedPublishingStatements: (state, value) => { 
        if(Object.keys(value).length === 0) state.expandedPublishingStatements = []
        else state.expandedPublishingStatements.push(value) 
    },

    // Filters & Actions & Buttons
    setSelectedPublishingStatementsReportOption: (state, selectedOption) => { state.selectedPublishingStatementsReportOption = selectedOption },
    setSelectedPublishingStatementsAction: (state, selectedAction) => { state.selectedPublishingStatementsAction = selectedAction },
    //Statement preview
    setPublishingStatementsStatementPreviewDialogDetailsStatementPreviewDate: (state, value) => { state.publishingStatementsStatementPreviewDialogDetailsStatementPreviewDate = value },
    setPublishingStatementsStatementPreviewDialogCreatePdfCheckbox:           (state, value) => { state.publishingStatementsStatementPreviewDialogCreatePdfCheckbox = value },
    setPublishingStatementsStatementPreviewDialogC3CalculationCheckbox:       (state, value) => { state.publishingStatementsStatementPreviewDialogC3CalculationCheckbox = value },
    
    // Archiving
    setShowPublishingStatementsArchivingDialog:             (state, value) => { state.showPublishingStatementsArchivingDialog = value },
    setPublishingStatementsArchivingInProgress:             (state, value) => { state.publishingStatementsArchivingInProgress = value },
    setPublishingStatementsArchivingTargetCurrency:         (state, value) => { state.publishingStatementsArchivingTargetCurrency = value },
    setPublishingStatementsArchivingShowCcfField:           (state, value) => { state.publishingStatementsArchivingShowCcfField = value },
    setPublishingStatementsArchivingDetailsCcf:             (state, value) => { state.publishingStatementsArchivingCcf = value },

    setPublishingStatementsDetails: (state, details) => { state.publishingStatementsDetails = details },
    setSelectedPublishingStatementsArchive: (state, selected) => { state.selectedPublishingStatementsArchive = selected },
    setSelectedPublishingStatementsForDeleteArchive: (state, alvId) => { state.selectedPublishingStatementsForDeleteArchive = alvId },

    // Period Filter
    setSelectedPeriodValues: (state, selectedValues) => { state.selectedPeriodValues = selectedValues },
    setSelectedPeriodNumberPublishingStatements: (state, newNumber) => { state.selectedPeriodValues.number = newNumber },
    setSelectedPeriodTimeUnitPublishingStatements: (state, newValue) => { state.selectedPeriodValues.timeUnit = newValue },
    setSelectedPeriodYearPublishingStatements: (state, newYear) => { state.selectedPeriodValues.year = newYear },    
    setRunningPublishingStatementsPercentValues: (state, percentValues) => { state.runningPublishingStatementsPercentValues = percentValues },
    setIsPublishingStatementsRunning: (state, value) => { state.isPublishingStatementsRunning = value },

    // Royalty Controlling
    setShowPublishingStatementsRoyaltyControllingDialog:        (state, show) => { state.showPublishingStatementsRoyaltyControllingDialog = show },
    setPublishingStatementsRoyaltyControllingDialogText:        (state, text) => { state.publishingStatementsRoyaltyControllingDialogText = text },
    setPublishingStatementsRoyaltyControllingShowProgressbar:   (state, show) => { state.publishingStatementsRoyaltyControllingShowProgressbar = show },
    setPublishingStatementsRoyaltyControllingProgressbarValue:  (state, value) => { state.publishingStatementsRoyaltyControllingProgressbarValue = value },
    setPublishingStatementsRoyaltyControllingPath:              (state, path) => { state.publishingStatementsRoyaltyControllingPath = path },
    setPublishingStatementsRoyaltyControllingDialogPolling:     (state, polling) => { state.publishingStatementsRoyaltyControllingDialogPolling = polling },
    setPublishingStatementsRoyaltyControllingInProcess:         (state, status) => { state.publishingStatementsRoyaltyControllingInProcess = status },
    setShowPublishingStatementsRoyaltyControllingDialogConfirmationButton: (state, show) => { state.showPublishingStatementsRoyaltyControllingDialogConfirmationButton = show },
    setSelectedPublishingStatementsReportDropdown:              (state, value) => { state.selectedPublishingStatementsReportDropdown = value },
    setPublishingStatementsRoyaltyControllingDialogAction:      (state, value) => { state.publishingStatementsRoyaltyControllingDialogAction = value },
    setPublishingStatementsGroupIdsForMapping:                 (state, value) => { state.publishingStatementsGroupIdsForMapping = value },

    // Bank file dialog
    setShowPublishingStatementsBankFileDialog:                 (state, show) => { state.showPublishingStatementsBankFileDialog = show },
    setPublishingStatementsBankFileDialogDebtor:               (state, debtor) => { state.publishingStatementsBankFileDialogDebtor = debtor },
    setPublishingStatementsBankFileDialogType:                 (state, type) => { state.publishingStatementsBankFileDialogType = type },
    setPublishingStatementsBankFileDialogExecutionDate:        (state, date) => { state.publishingStatementsBankFileDialogExecutionDate = date },
    setPublishingStatementsBankFileDialogIsSubmitting:         (state, value) => { state.publishingStatementsBankFileDialogIsSubmitting = value },
    setPublishingStatementsBankFileDialogError:                (state, value) => { state.publishingStatementsBankFileDialogError = value },
    // Full reset - used on close (X / backdrop / submit success) and on dialog
    // component beforeDestroy, so that re-mounting the page (e.g. after navigating
    // to A-Z and back) does NOT pop the dialog open with stale state.
    resetPublishingStatementsBankFileDialog: (state) => {
        state.showPublishingStatementsBankFileDialog       = false
        state.publishingStatementsBankFileDialogDebtor     = null
        state.publishingStatementsBankFileDialogType       = null
        state.publishingStatementsBankFileDialogExecutionDate = null
        state.publishingStatementsBankFileDialogIsSubmitting  = false
        state.publishingStatementsBankFileDialogError      = null
    },
}

const actions = {
// FETCH Staments
    async fetchPublishingStatements({ state, commit, getters }) {
        commit('setIsLoading', true)

        
        // check for set filters
        const periodNumber = getters.getSelectedPeriodNumberPublishingStatements
        const periodTimeUnit = getters.getSelectedPeriodTimeUnitPublishingStatements
        const periodYear = getters.getSelectedPeriodYearPublishingStatements
        let period = null
        if (periodTimeUnit === 'year' && periodYear) {
            period = 'year,' + periodYear
        } else if (periodNumber && periodTimeUnit && periodYear) {
            period = periodNumber + ',' + periodTimeUnit + ',' + periodYear
        }
        let filterObj = {
            'search' :  getters.getPublishingStatementsSearch,
            'archiveFilter' : getters.getSelectedPublishingStatementsArchiveFilter,
            'period' : period
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        const options = getters.getPublishingStatementsServerSideSortingOptions
        const query = {
            params: paramsString,
            sortBy: [...options.sortBy],
            sortDesc: [...options.sortDesc],
            page: getters.getCurrentPage
        }
        commit('setPublishingStatementsPendingQuery', query)
        commit('setSelectedPublishingStatements', [])
        commit('setIsAllSelectedPublishingStatements', false)
        commit('setPublishingStatementsActionRows', null)
        try {
            const response = await api.getListData2(DIR, query.page, query.sortBy, query.sortDesc, query.params)
            // An older search must not replace a newer page or its action scope.
            if (state.publishingStatementsPendingQuery !== query) return
            if (!response || response.error === 1 || !Array.isArray(response.list)) throw new Error('Statement search failed')
            commit('setPublishingStatements', response.list)
            commit('setPublishingStatementsLastQuery', {
                ...query,
                count: Number(response.filteredRecords),
                searchSession: response.searchSession
            })
            if (!response.list.length) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        } catch (error) {
            if (state.publishingStatementsPendingQuery !== query) return
            commit('setPublishingStatements', [])
            commit('setPublishingStatementsLastQuery', null)
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_UNKNOWN') })
        } finally {
            if (state.publishingStatementsPendingQuery === query) {
                commit('setPublishingStatementsPendingQuery', null)
                commit('setIsLoading', false)
            }
        }
    },

    // The database stores the last search. Keep only its reference and a small
    // summary in the browser; action endpoints resolve all matching IDs.
    async preparePublishingStatementsAction({ state, getters, commit, dispatch }, { allowAllResults = false } = {}) {
        if (state.publishingStatementsResolvingAction || state.publishingStatementsPendingQuery) return false
        commit('setPublishingStatementsActionRows', null)
        const query = state.publishingStatementsLastQuery
        const selected = [...getters.getSelectedPublishingStatements]
        if (!selected.length && !allowAllResults) {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
            commit('setShowSelectionRequiredDialog', true)
            return false
        }
        commit('setPublishingStatementsResolvingAction', true)
        try {
            if (selected.length) {
                const rows = getters.getPublishingStatements.filter(row => selected.includes(row.alvId))
                if (rows.length !== selected.length) throw new Error('Selection is no longer on this page')
                commit('setPublishingStatementsActionRows', rows)
            } else {
                if (!query || !Number.isInteger(query.count) || query.count <= 0) {
                    commit('setSnackbar', { type: 'warning', msg: i18n.t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') })
                    return false
                }
                if (!await dispatch('runConfirmationDialog')) return false
                if (state.publishingStatementsLastQuery !== query || state.publishingStatementsPendingQuery) return false
                if (!query.searchSession) throw new Error('Missing statement search session')
                const response = await api.getResponse(api.getRootUrl() + DIR +
                    '?action=getActionScope&searchSession=' + encodeURIComponent(query.searchSession))
                if (!response || response.error === 1 || !response.response) {
                    throw new Error(response && response.response && response.response.errorMsg || 'lang_GENERIC_MESSAGE_ERROR_UNKNOWN')
                }
                const scope = response.response
                if (scope.searchSession !== query.searchSession || scope.count !== query.count) {
                    throw new Error('The statement search has changed. Refresh the list and try again.')
                }
                if (state.publishingStatementsLastQuery !== query || state.publishingStatementsPendingQuery) return false
                commit('setPublishingStatementsActionRows', [])
                commit('setPublishingStatementsActionScope', scope)
            }
            return true
        } catch (error) {
            commit('setSnackbar', { type: 'error', msg: i18n.te(error.message) ? i18n.t(error.message) : error.message })
            return false
        } finally {
            commit('setPublishingStatementsResolvingAction', false)
        }
    },

    // DETAILS
    async fetchPublishingStatementsDetails({ commit }, alvId) {
        let values

        let response = await api.getDetailsById(DIR, alvId)

        if(response === undefined || response.length === 0 || response.error === 1) {
            response = {}
            commit('setSnackbar', {
                type: 'error',
                msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
            })
        } else values = response
        

        commit('setPublishingStatementsDetails', values)
        commit('setIsLoading', false)
    },

// ACTIONS Switch
    async doPublishingStatementsAction({ dispatch, commit, getters }) {
        let selectedStatements = getters.getSelectedPublishingStatements

        if (getters.getSelectedPublishingStatementsAction === 'assignTemplates') {
            const allStatements = getters.getPublishingStatements
            let licensorAlvIds

            if (selectedStatements.length === 0) {
                let r = await dispatch('runConfirmationDialog')
                if (!r) return
                licensorAlvIds = allStatements.map(s => s.licensor.alvId)
            } else {
                const selectedObjects = allStatements.filter(s => selectedStatements.includes(s.alvId))
                licensorAlvIds = selectedObjects.map(s => s.licensor.alvId)
            }

            const personIds = licensorAlvIds.filter(id => id.endsWith('AP'))
            const groupIds = licensorAlvIds.filter(id => id.endsWith('AG'))

            commit('setSelectedAzPersons', personIds)
            commit('setAssignAllAzPersons', false)
            commit('setPublishingStatementsGroupIdsForMapping', groupIds)
            commit('setShowAzPersonsAssignTemplatesDialog', true)
            return
        }

        // ActionDropdown clears its value after dispatch, before confirmation resolves.
        const action = getters.getSelectedPublishingStatementsAction
        if (!['launchStatementRun', 'archiveWithForwarded', 'archiveWithoutForwarded', 'bulkDownload'].includes(action)) return
        const needsPeriod = action === 'launchStatementRun' || action === 'bulkDownload'
        if (needsPeriod && !await dispatch('validateSelectedPeriodForRoyaltyControlling')) {
            commit('setShowPeriodRequiredDialog', true)
            return
        }
        if (!await dispatch('preparePublishingStatementsAction', { allowAllResults: needsPeriod })) return
        selectedStatements = getters.getPublishingStatementsActionIds
        switch (action) {
            case 'launchStatementRun':
                commit('setIsPublishingStatementsRunning', false)
                commit('setRunningPublishingStatementsPercentValues', [])
                commit('setShowStatementPreviewDialog', true)
                break
            case 'archiveWithForwarded': case 'archiveWithoutForwarded':
                commit('setSelectedPublishingStatementsAction', action)
                commit('setShowPublishingStatementsArchivingDialog', true)
                break
            case 'bulkDownload': {
                const timeUnit = getters.getSelectedPeriodTimeUnitPublishingStatements
                const year = getters.getSelectedPeriodYearPublishingStatements
                const number = getters.getSelectedPeriodNumberPublishingStatements
                const period = timeUnit === 'year' ? `${timeUnit},${year}` : `${number},${timeUnit},${year}`
                try {
                    const response = await api.triggerAction(DIR, selectedStatements, { action, period, ...getters.getPublishingStatementsActionQuery })
                    if (!response || response.error === 1 || !response.response || !response.response.path) throw new Error('Download failed')
                    await api.getFileFromALV(response.response.path)
                    commit('setSnackbar', { type: 'success', msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL') })
                } catch (error) {
                    commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_UNKNOWN') })
                }
                break
            }
        }
    },

    // ARCHIVE Statements
    async archivePublishingStatements({ getters, dispatch, commit }, { addCreditNumber = true } = {}) {
        let selectedStatements = getters.getSelectedPublishingStatements
        if (!selectedStatements.length) return
        let ccfString = getters.getPublishingStatementsArchivingDetailsCcf || "" // from FE it is a string, e.g. "10,22" or "10.22"
        let ccf = parseFloat(ccfString.replace(/,/g, '.')) // convert comma to dot decimal separator, if needed
        if (isNaN(ccf)) {
            ccf = null; // Prevent sending NaN
        }
        
        let targetCurrency = getters.getPublishingStatementsArchivingTargetCurrency || null

        let metaData = { 
            "alvIds": selectedStatements, 
            "tags": { "add": getters.getAddTag, "remove": null },
            "ccf": ccf,
            "targetCurrency": targetCurrency,
            "addCreditNumber": addCreditNumber
        };
        let queryParams = { "action": getters.getSelectedPublishingStatementsAction }
        commit('setPublishingStatementsArchivingInProgress',true)

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_LABEL_STATEMTENS_SNACKBAR_ARCHIVING_SUCCESSFULL')
            })

        } else {
            let responseLangConst = response.response.errorMsg ? response.response.errorMsg : 'lang_LABEL_STATEMTENS_SNACKBAR_ARCHIVING_NOT_SUCCESSFULL';
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(responseLangConst)
            })
        }

        commit('setExpandedPublishingStatements', [])
        commit('setSelectedPublishingStatements', [])
        commit('setSelectedPublishingStatementsAction',[])
        commit('setPublishingStatementsArchivingDetailsCcf', null)
        commit('setIsAllSelectedPublishingStatements', false)
        commit('setPublishingStatementsArchivingInProgress',false)
        commit('setShowPublishingStatementsArchivingDialog', false)
        dispatch('fetchPublishingStatements')
    },

    // DELETE
    async deleteSelectedPublishingStatementsArchive({ getters, commit, dispatch}) {
        let response = await api.deleteEntries(DIR, [getters.getSelectedPublishingStatementsArchive.alvId])

        if(response.error === -1) {
            await dispatch('fetchPublishingStatementsDetails', getters.getSelectedPublishingStatementsForDeleteArchive)
            dispatch('fetchPublishingStatements')
        }
        let index = getters.getExpandedPublishingStatements.findIndex(statement => {
            return statement.alvId === getters.getSelectedPublishingStatementsForDeleteArchive
        })
        getters.getExpandedPublishingStatements.splice(index, 1)
        commit('setExpandedPublishingStatements', getters.getPublishingStatementsDetails)
        commit('setSelectedPublishingStatementsArchive', [])
    },

    async publishingStatemtensRoyaltyControlling({ commit, getters, dispatch }, action) {
        let polling = getters.getPublishingStatementsRoyaltyControllingDialogPolling
        let selectedTimeUnit = getters.getSelectedPeriodTimeUnitPublishingStatements
        let selectedPeriodNumber = getters.getSelectedPeriodNumberPublishingStatements
        let selectedPerdiodYear = getters.getSelectedPeriodYearPublishingStatements
        
        let period = ''
        if(selectedTimeUnit === 'year') period += selectedTimeUnit + ',' + selectedPerdiodYear
        else period += selectedPeriodNumber + ',' + selectedTimeUnit + ',' + selectedPerdiodYear

        let params = {
            "action": action,
            "period": period
        }
        let startRoyaltyControllingResponse = await api.triggerAction(DIR, [], params)

        commit('setShowPublishingStatementsRoyaltyControllingDialog', false)
        if(startRoyaltyControllingResponse.error === 1) {
            let errorMsg = startRoyaltyControllingResponse.response.errorMsg

            commit('setShowPublishingStatementsRoyaltyControllingDialog', true)
            commit('setPublishingStatementsRoyaltyControllingDialogText', this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg)
            commit('setPublishingStatementsRoyaltyControllingInProcess', false)
        } else {
            // Process
            let processResult = await dispatch('processPublishingStatementsRoyaltyControlling', { processId: startRoyaltyControllingResponse.processId, polling: polling, action: action })

            if(processResult.status === 'running') {
                polling = setInterval(() => {
                    dispatch('processPublishingStatementsRoyaltyControlling', { processId: startRoyaltyControllingResponse.processId, polling: polling, action: action }) 
                }, 3000)                
            }
        }
    },
    async processPublishingStatementsRoyaltyControlling({ commit }, params) {
        let result = await api.getProgressOfProcess(params.processId, params.polling).then(response => { return response })
        commit('setPublishingStatementsRoyaltyControllingProgressbarValue', result.percent)

        if(result.status === 'finished') {
            // Download is now handled via Ably notifications in Dashboard
            commit('setPublishingStatementsRoyaltyControllingInProcess', false)
            commit('setShowPublishingStatementsRoyaltyControllingDialog', false)
            commit('setPublishingStatementsRoyaltyControllingProgressbarValue', null)
            clearInterval(params.polling)
            if(result.error === 1) {
                commit('setPublishingStatementsRoyaltyControllingInProcess', false)
                commit('setShowPublishingStatementsRoyaltyControllingDialog', true)
                commit('setPublishingStatementsRoyaltyControllingDialogText', result.errorMsg)
                commit('setPublishingStatementsRoyaltyControllingProgressbarValue', null)

            }
        }
        return result
    },
    validateSelectedPeriodForRoyaltyControlling({commit, getters}) {
        let selectedTimeUnit        = getters.getSelectedPeriodTimeUnitPublishingStatements
        let selectedPeriodNumber    = getters.getSelectedPeriodNumberPublishingStatements
        let selectedPerdiodYear     = getters.getSelectedPeriodYearPublishingStatements

        if(selectedTimeUnit !== '' && selectedTimeUnit !== undefined && selectedTimeUnit !== null) {
            switch(selectedTimeUnit) {
                case 'month': case 'quarter': case 'halfyear':
                    if( (selectedPeriodNumber !== null && selectedPeriodNumber !== undefined) &&
                        (selectedPerdiodYear !== null && selectedPerdiodYear !== undefined)) {
                        return true;                                                    
                    } else {
                        return false;
                    }
                case 'year': 
                    if(selectedPerdiodYear !== null && selectedPerdiodYear !== undefined) {                        
                        return true;                       
                    } else {
                        return false;
                    }
            }
        } else {
            return false;
        }
    },
    async doPublishingStatementsReportDropdown({ commit, getters, dispatch }) {
        const value = getters.getSelectedPublishingStatementsReportDropdown;
        const isPeriodValid = await dispatch('validateSelectedPeriodForRoyaltyControlling')

        console.log(isPeriodValid)
        if (!isPeriodValid) {
            commit('setShowPeriodRequiredDialog', true)
            commit('setShowPublishingStatementsRoyaltyControllingDialogConfirmationButton', false)
            return;
        }

        switch (value) {
            case 'journal':
                if (!getters.getPublishingStatementsJournalInProcess) commit('setShowPublishingStatementsJournalDialog', true)
                break
            case 'faktura':
                await dispatch('downloadPublishingStatementsFaktura')
                break
            case 'royaltyControlling':
                // Download is now handled via Ably notifications in Dashboard
                commit('setPublishingStatementsRoyaltyControllingDialogAction', 'royaltyControlling')
                commit('setShowPublishingStatementsRoyaltyControllingDialog', true)
                commit('setPublishingStatementsRoyaltyControllingDialogText',  i18n.t('lang_GENERIC_CAPTION_BACKGROUND_PROCESS_START_CONFIRMATION')) 
                commit('setShowPublishingStatementsRoyaltyControllingDialogConfirmationButton', true)
                break
            case 'generateBankFile': {
                let selectedStatements = getters.getSelectedPublishingStatements
                if (selectedStatements.length === 0) {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
                    commit('setShowSelectionRequiredDialog', true)
                    return
                }

                await dispatch('openPublishingStatementsBankFileDialog')
                break
            }
        }
    },

    async downloadPublishingStatementsJournal({ commit, getters, dispatch }, { onlyArchived = true } = {}) {
        if (getters.getPublishingStatementsJournalInProcess) return
        if (!await dispatch('validateSelectedPeriodForRoyaltyControlling')) {
            commit('setShowPeriodRequiredDialog', true)
            return
        }
        const timeUnit = getters.getSelectedPeriodTimeUnitPublishingStatements
        const year = getters.getSelectedPeriodYearPublishingStatements
        const number = getters.getSelectedPeriodNumberPublishingStatements
        const period = timeUnit === 'year' ? `${timeUnit},${year}` : `${number},${timeUnit},${year}`

        commit('setPublishingStatementsJournalInProcess', true)
        try {
            const response = await api.triggerAction(DIR, { onlyArchived }, { action: 'journal', period })
            const result = response && (response.response || response)
            const path = result && (result.path || result.txt)
            if (!result || response.error === 1 || result.error === 1 || !path) {
                const message = (result && result.errorMsg) || 'lang_GENERIC_MESSAGE_ERROR_UNKNOWN'
                commit('setSnackbar', { type: 'error', msg: i18n.te(message) ? i18n.t(message) : message })
                return
            }
            await api.getFileFromALV(path)
            return true
        } catch (error) {
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_UNKNOWN') })
        } finally {
            commit('setPublishingStatementsJournalInProcess', false)
        }
    },

    async downloadPublishingStatementsFaktura({ commit, getters, dispatch }) {
        if (getters.getPublishingStatementsFakturaInProcess) return
        if (!await dispatch('validateSelectedPeriodForRoyaltyControlling')) {
            commit('setShowPeriodRequiredDialog', true)
            return
        }
        const timeUnit = getters.getSelectedPeriodTimeUnitPublishingStatements
        const year = getters.getSelectedPeriodYearPublishingStatements
        const number = getters.getSelectedPeriodNumberPublishingStatements
        const period = timeUnit === 'year' ? `${timeUnit},${year}` : `${number},${timeUnit},${year}`

        commit('setPublishingStatementsFakturaInProcess', true)
        try {
            const response = await api.triggerAction(DIR, {}, { action: 'faktura', period })
            const result = response && (response.response || response)
            const path = result && (result.path || result.txt)
            if (!result || response.error === 1 || result.error === 1 || !path) {
                const message = (result && result.errorMsg) || 'lang_GENERIC_MESSAGE_ERROR_UNKNOWN'
                commit('setSnackbar', { type: 'error', msg: i18n.te(message) ? i18n.t(message) : message })
                return
            }
            await api.getFileFromALV(path)
        } catch (error) {
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_UNKNOWN') })
        } finally {
            commit('setPublishingStatementsFakturaInProcess', false)
        }
    },

    /**
     * Opens the "create bank file" dialog. Fetches the active publishing
     * company's debtor bank info (bank name / IBAN / BIC) so the dialog can
     * render the SEPA option label "{bankName} SEPA" and link to the A-Z
     * Finance panel when bank data is incomplete. Also seeds the execution
     * date with today + 5 business days as a default.
     */
    async openPublishingStatementsBankFileDialog({ commit }) {
        commit('setPublishingStatementsBankFileDialogDebtor', null)
        // Format dropdown starts empty - user must explicitly pick a format,
        // and only THEN the format-specific bank-data validation kicks in.
        commit('setPublishingStatementsBankFileDialogType', null)
        commit('setPublishingStatementsBankFileDialogExecutionDate', addBusinessDaysISO(new Date(), 5))
        commit('setPublishingStatementsBankFileDialogError', null)
        commit('setShowPublishingStatementsBankFileDialog', true)

        let url = api.getRootUrl() + DIR + '?action=getDebtorBankInfo'
        let response = await api.getResponse(url)

        if (!response || response.error === 1) {
            let errorMsg = (response && response.response && response.response.errorMsg) || 'lang_GENERIC_MESSAGE_ERROR_UNKNOWN'
            commit('setSnackbar', { type: 'error', msg: i18n.t(errorMsg) })
            commit('setShowPublishingStatementsBankFileDialog', false)
            return
        }

        commit('setPublishingStatementsBankFileDialogDebtor', response.response)
    },

    /**
     * Submits the bank file generation with the chosen type + execution date.
     * Posts to /publishing/statements?action=generateBankFile, downloads the
     * resulting file and shows a snackbar (success / partial-with-skipped / error).
     */
    async submitPublishingStatementsBankFileGeneration({ commit, getters }) {
        let selectedStatements = getters.getSelectedPublishingStatements
        if (selectedStatements.length === 0) {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE')
            commit('setShowSelectionRequiredDialog', true)
            return
        }

        let selectedTimeUnit = getters.getSelectedPeriodTimeUnitPublishingStatements
        let selectedPeriodNumber = getters.getSelectedPeriodNumberPublishingStatements
        let selectedPeriodYear = getters.getSelectedPeriodYearPublishingStatements
        let period = null
        if (selectedTimeUnit === 'year') {
            period = selectedTimeUnit + ',' + selectedPeriodYear
        } else {
            period = selectedPeriodNumber + ',' + selectedTimeUnit + ',' + selectedPeriodYear
        }

        let bankFileType  = getters.getPublishingStatementsBankFileDialogType || 'sepa'
        let executionDate = getters.getPublishingStatementsBankFileDialogExecutionDate

        commit('setPublishingStatementsBankFileDialogIsSubmitting', true)
        commit('setPublishingStatementsBankFileDialogError', null)
        try {
            let queryParams = { 'action': 'generateBankFile', 'period': period, 'bankFileType': bankFileType }
            if (executionDate) queryParams['executionDate'] = executionDate

            let bankFileResponse = await api.triggerAction(DIR, selectedStatements, queryParams)

            if (bankFileResponse.error === 1) {
                let errorMsg = (bankFileResponse.response && bankFileResponse.response.errorMsg) || 'lang_GENERIC_MESSAGE_ERROR_UNKNOWN'
                let skipped  = (bankFileResponse.response && bankFileResponse.response.skipped) || []
                let selfTransferConflicts = (bankFileResponse.response && bankFileResponse.response.selfTransferConflicts) || []
                let accountHolderConflicts = (bankFileResponse.response && bankFileResponse.response.accountHolderConflicts) || []
                let currencyConflicts = (bankFileResponse.response && bankFileResponse.response.currencyConflicts) || []
                commit('setPublishingStatementsBankFileDialogError', {
                    errorMsg: errorMsg,
                    skipped: skipped,
                    selfTransferConflicts: selfTransferConflicts,
                    accountHolderConflicts: accountHolderConflicts,
                    currencyConflicts: currencyConflicts
                })
                return
            }

            api.getFileFromALV(bankFileResponse.response.path)

            let skippedCount   = (bankFileResponse.response && bankFileResponse.response.skippedCount) || 0
            let warningCount   = (bankFileResponse.response && bankFileResponse.response.warningCount) || 0
            let manualAwvCount = (bankFileResponse.response && bankFileResponse.response.manualAwvCount) || 0
            let schemaValid    = bankFileResponse.response && bankFileResponse.response.schemaValid !== false

            // Snackbar precedence: hard schema error > skipped creditors > manual AWV
            // (foreign file only) > generic warnings > success. Manual AWV is treated as a
            // warning because the bank file itself is fine - the user just has to do
            // an extra step in the Bundesbank online portal for >50k payments.
            if (!schemaValid) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: i18n.t('lang_PUBLISHING_STATEMENTS_MESSAGE_ERROR_BANK_FILE_SCHEMA_INVALID')
                })
            } else if (skippedCount > 0) {
                commit('setSnackbar', {
                    type: 'warning',
                    msg: i18n.t('lang_PUBLISHING_STATEMENTS_MESSAGE_WARNING_CREDITORS_SKIPPED_ZIP', { count: skippedCount })
                })
            } else if (manualAwvCount > 0) {
                commit('setSnackbar', {
                    type: 'warning',
                    msg: i18n.t('lang_PUBLISHING_STATEMENTS_MESSAGE_WARNING_MANUAL_AWV_REPORTS', { count: manualAwvCount })
                })
            } else if (warningCount > 0) {
                commit('setSnackbar', {
                    type: 'warning',
                    msg: i18n.t('lang_PUBLISHING_STATEMENTS_MESSAGE_WARNING_BANK_FILE_DATA_QUALITY', { count: warningCount })
                })
            } else {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }

            commit('resetPublishingStatementsBankFileDialog')
            // Clear the row selection after a successful run (mirrors the archiving
            // flow) so a previously selected licensor does not stick around and get
            // silently re-included in the next bank file generation.
            commit('setSelectedPublishingStatements', [])
            commit('setIsAllSelectedPublishingStatements', false)
        } catch (e) {
            console.error('submitPublishingStatementsBankFileGeneration error:', e)
            commit('setSnackbar', { type: 'error', msg: i18n.t('lang_GENERIC_MESSAGE_ERROR_UNKNOWN') })
        } finally {
            commit('setPublishingStatementsBankFileDialogIsSubmitting', false)
        }
    },
}

// Returns ISO YYYY-MM-DD of `start` plus N business days (skipping Sat/Sun).
function addBusinessDaysISO(start, days) {
    let d = new Date(start.getTime())
    let added = 0
    while (added < days) {
        d.setDate(d.getDate() + 1)
        let dow = d.getDay() // 0=Sun .. 6=Sat
        if (dow !== 0 && dow !== 6) added++
    }
    let yyyy = d.getFullYear()
    let mm = String(d.getMonth() + 1).padStart(2, '0')
    let dd = String(d.getDate()).padStart(2, '0')
    return yyyy + '-' + mm + '-' + dd
}

export default {
    state, getters, actions, mutations
}